var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',[_c('sr-open-assessments',{attrs:{"frameworkId":_vm.framework.id,"title":_vm.title,"hideFilter":"","routeName":"AssessmentHome","routeProps":{ query: { frameworkId: _vm.framework.id } },"headers":_vm.headers}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }